import { render, staticRenderFns } from "./distributionPoster.vue?vue&type=template&id=543e9d08&scoped=true&"
import script from "./distributionPoster.vue?vue&type=script&lang=js&"
export * from "./distributionPoster.vue?vue&type=script&lang=js&"
import style0 from "./distributionPoster.vue?vue&type=style&index=0&id=543e9d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543e9d08",
  null
  
)

export default component.exports